<template>
  <div class="hello"  style="height:700px; background-color: #f7f8fa; padding-bottom: 40px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="onClickLeft" safe-area-inset-top>
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">收貨資料</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <van-tabs  color="rgb(53, 120, 229)" v-model="active" sticky @click="getAddressList">
      <van-tab title="宅配地址">
        <van-swipe-cell  v-for="(item,index) in addrList" :key= "index" style="margin-top:10px; margin-right: 10px; margin-left: 10px;">
          <van-cell size="large" :border="false" is-link center @click="onEdit(index,item.id)">
            <template #title>
              <span style="font-size:16px;">{{item.name + ' ' + item.tel}}</span>
            </template>
            <template #label>
              <span style="font-size:12px;">{{item.address}}</span>
            </template>
            <template  #right-icon>
              <van-icon name="arrow" color="#969799" size="20px" />
            </template>
          </van-cell>
          <template #right>
            <van-button square type="danger" text="刪除" class="delete-button" />
          </template>
        </van-swipe-cell>
      </van-tab>
      <van-tab title="超取地址">
        <van-swipe-cell  v-for="(item,index) in addrList" :key= "index" style="margin-top:10px; margin-right: 10px; margin-left: 10px;">
          <van-cell size="large" :border="false" is-link center @click="onEdit(index,item.id)">
            <template #title>
              <span style="font-size:16px;">{{item.name + ' ' + item.tel}}</span>
            </template>
            <template #label>
              <span style="font-size:12px;">{{item.address}}</span>
            </template>
            <template  #right-icon>
              <van-icon name="arrow" color="#969799" size="20px" />
            </template>
          </van-cell>
          <template #right>
            <van-button square type="danger" text="刪除" class="delete-button" @click="onDelete"/>
          </template>
        </van-swipe-cell>
      </van-tab>
    </van-tabs>
    <div  style="margin-left: 10px; margin-right: 10px; margin-top:20px;">
      <van-button type="info" size="large" to="/address/add">新增地址</van-button>
    </div>
  </div>
</template>
<script>
import { getAddrList, deleteAddr } from '@/api/address'
import { Notify, Dialog, Toast } from 'vant'
import { getUser } from '@/utils/auth'
export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      active: 0,
      addrList: []
    }
  },
  created () {
    this.getAddressList()
  },
  mounted () {
  },
  methods: {
    onSubmit () {
    },
    onDelete () {
      Dialog.confirm({
        title: '通知',
        message: '資料將徹底刪除，確定刪除該收貨資料嗎?',
        confirmButtonText: '確認',
        confirmButtonColor: 'red'
      })
        .then(() => {
          if (this.edit === true) {
            deleteAddr({ customer: getUser(), id: this.$route.params.id }).then(res => {
              if (res.code === 200) {
                Notify({ type: 'success', message: '刪除地址成功' })
                this.$router.back(-1)
                window.scrollTo(0, 0)
              } else {
                Notify({ type: 'danger', message: res.message })
              }
            })
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    onEdit (index, id) {
      this.$router.push({ path: '/address/edit/' + id })
    },
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    getAddressList () {
      this.addrList = []
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getAddrList({ user: getUser(), type: this.active + 1 }).then(res => {
        if (res.code === 200) {
          this.addrList = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
  .van-button--block {
    background-color: rgb(53, 120, 229);
    border: 1px solid rgb(53, 120, 229);

  }
  .van-address-list__bottom {
    position: fixed;
    min-width: 320px;
    max-width: 640px;
  }
  .delete-button {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Address.vue